export default "__VITE_ASSET__rPrv8Je8__"